export default function LoadingSpinner({ label = 'Loading…', full = false }) {
  return (
    <div
      className="center"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 12,
        padding: full ? '25dvh 16px' : '32px 16px',
      }}
    >
      <div className="spinner spinner-teal" />
      {label && <div className="muted" style={{ fontSize: 14 }}>{label}</div>}
    </div>
  )
}
